import { ModelConceptClass } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { changeModelConceptRelationshipConnection } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/changeModelConceptRelationshipConnection';
import { getConnectedRelationshipDataForClass } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/getConnectedRelationshipDataForClass';

export const disconnectAllRelationshipsFromClass =
  (data: ModelConceptClass) => (model: Model) => {
    getConnectedRelationshipDataForClass(model, data.value).forEach(
      (linkData) => {
        const fromIri = linkData.from
          ? getModelConceptClassValue(linkData.from)
          : undefined;
        const toIri = linkData.to
          ? getModelConceptClassValue(linkData.to)
          : undefined;
        changeModelConceptRelationshipConnection({
          key: linkData.key,
          fromIri: linkData.from === data.key ? undefined : fromIri,
          toIri: linkData.to === data.key ? undefined : toIri,
        })(model);
      }
    );
  };
